require('./styles/main.global.scss');